import { Box, Button } from '@mui/material'

import { ExportSmartPayCsvFromInputFileResult } from 'types'

interface ExportActionsProps {
  result: ExportSmartPayCsvFromInputFileResult | null
  onDownloadExportCsv: () => void
  onDownloadNotExportedCsv: () => void
  onUploadNewFile: () => void
}

export const ExportActions = ({
  result,
  onDownloadExportCsv,
  onDownloadNotExportedCsv,
  onUploadNewFile,
}: ExportActionsProps) => {
  return (
    <Box flex='1' display='flex' flexDirection='column' alignItems='center'>
      
      {result?.exportCsv && (
        <Box sx={{ mt: 3 }}>
          <Button variant='contained' style={{width: '30vw'}} onClick={onDownloadExportCsv}>
            Download SmartPay Export CSV
          </Button>
        </Box>
      )}
      {result?.notExportedCsv && (
        <Box sx={{ mt: 2 }}>
          <Button variant='contained' style={{width: '30vw'}} onClick={onDownloadNotExportedCsv}>
            Download Not Exported CSV
          </Button>
        </Box>
      )}
      <Button variant='outlined' style={{width: '30vw'}} onClick={onUploadNewFile} sx={{ mt: 2 }}>
        Upload new input file
      </Button>
    </Box>
  )
}
